import React from "react";
import { ProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";

import {
  ProcedureQuotaContextProps,
  ProcedureQuotaService,
} from "../../../../application/service/smart-apply/procedure-detail/procedure-quota-service";
import { UpdateButton } from "./update-button";
import { connectService } from "@graffer-inc/smart-apply";
import { useMount } from "../../../../utils/custom-hooks";
import { TextField } from "@graffer-inc/console-design-kit";

export const QuotaSetting: React.FC<ProcedureQuotaContextProps> = ({
  procedure,
  procedureQuota,
  isReachedQuota,
  isLoading,
  onMountSetting,
  onChange,
  onSave,
}) => {
  useMount(onMountSetting);

  // 認証設定が行われている場合は上限設定無効
  if (procedure.requireJPKISignature() || procedure.requireMOJSignature()) {
    return <QuotaSettingConflictMessage />;
  }

  if (isLoading) return <></>;
  return (
    <div className="is-flex is-justify-content-space-between is-flex-wrap-wrap">
      <div>
        <TextField
          label={"申請数の上限設定"}
          type="number"
          min="1"
          max="10000"
          description={explanation}
          placeholder={""}
          value={procedureQuota.quota ? String(procedureQuota.quota) : ""}
          onChange={(e) => {
            onChange({
              ...procedureQuota,
              quota: e.target.value
                ? Math.min(
                    Math.max(Number(e.target.min), Number(e.target.value)),
                    Number(e.target.max),
                  )
                : undefined,
            });
          }}
          fullWidth={false}
        />
        {isReachedQuota ? (
          <p className="help has-text-weight-bold is-danger">
            上限に達したため受け付けを締め切りました。再開するには、上限を
            {procedureQuota.count + 1}以上に設定してください。
          </p>
        ) : (
          <p className="help has-text-weight-normal">
            {procedureQuota.createdAt
              ? "現在の申請数は" + procedureQuota.count + "件です。"
              : ""}
            上限に達すると申請の受け付けが自動的に停止します。
            手続き公開後でも上限数は変更できます。
          </p>
        )}
      </div>
      {(procedure.isDraft() || procedureQuota.createdAt) && (
        <UpdateButton
          procedure={procedure}
          canModifyAfterPublish={true}
          onClick={onSave}
        />
      )}
    </div>
  );
};

const explanation = [
  "申請数の上限が設定できます。認証設定とは併用できません。",
  "手続きの公開後に、新規設定や解除はできません。",
].join("\n");

const QuotaSettingConflictMessage: React.FC = () => (
  <div className="notification is-warning is-light">
    <div>
      <span className={`icon has-text-warning`}>
        <i className={`fas fa-exclamation-triangle`} />
      </span>
      <strong>申請数の上限設定ができません</strong>
    </div>
    <div className="content is-size-7 ml-5 mt-1">
      <b>認証設定が行われている手続きでは申請数の上限設定ができません。</b>
    </div>
  </div>
);

export const QuotaSettingContainer = connectService<
  { procedure: ProcedureEntity },
  ProcedureQuotaContextProps,
  ProcedureQuotaService
>(
  QuotaSetting,
  (p) =>
    new ProcedureQuotaService({
      procedure: p.procedure,
    }),
);
